'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var inputStyles = {
    contained: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    & + .select-button-label {\n      border: ", ";\n      font-weight: 700;\n\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n    &:checked + label {\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    & + .select-button-label {\n      border: ", ";\n      font-weight: 700;\n\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n    &:checked + label {\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return "1px solid " + theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    outlined: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    & + .select-button-label {\n      border: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n\n    &:checked + label {\n      color: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n  "], ["\n    & + .select-button-label {\n      border: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n\n    &:checked + label {\n      color: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return "1px solid " + theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
};
var inputSizeStyles = {
    sm: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    & + .select-button-label {\n      font-size: 14px;\n      padding: 12px 16px;\n    }\n  "], ["\n    & + .select-button-label {\n      font-size: 14px;\n      padding: 12px 16px;\n    }\n  "]))),
    md: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    & + .select-button-label {\n      font-size: 16px;\n      padding: 16px 20px;\n    }\n  "], ["\n    & + .select-button-label {\n      font-size: 16px;\n      padding: 16px 20px;\n    }\n  "]))),
};
var FormLabel = styled__default.label(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  display: block;\n  border-radius: 5px;\n  text-align: center;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  display: block;\n  border-radius: 5px;\n  text-align: center;\n  color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
});
var FormInput = styled__default.input(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  opacity: 0;\n\n  ", "\n  ", "\n"], ["\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  opacity: 0;\n\n  ", "\n  ", "\n"])), function (_a) {
    var variant = _a.variant;
    return inputStyles[variant];
}, function (_a) {
    var sizeOption = _a.sizeOption;
    return inputSizeStyles[sizeOption];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.FormInput = FormInput;
exports.FormLabel = FormLabel;
